var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel panel-bordered" },
    [
      _c("div", { staticClass: "panel-heading" }, [
        _c("h3", { staticClass: "panel-title" }, [_vm._v("Questions")]),
        _c("div", { staticClass: "panel-actions panel-actions-keep" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-round btn-primary btn-sm",
              attrs: { type: "button", disabled: _vm.disableAddButton },
              on: { click: _vm.openCreateModal },
            },
            [
              _c("i", {
                staticClass: "icon md-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" Add Question "),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "panel-body" },
        [
          _c("loading", {
            attrs: {
              active: _vm.isLoading,
              "is-full-page": false,
              loader: "bars",
            },
          }),
          _vm.questions.length
            ? _c(
                "div",
                { staticClass: "question-list" },
                _vm._l(_vm.questions, function (question, index) {
                  return _c("QuestionCard", {
                    key: question.id,
                    attrs: { index: index, question: question },
                    on: {
                      edit: function ($event) {
                        return _vm.openEditModal(question)
                      },
                      delete: function ($event) {
                        return _vm.deleteQuestion(question)
                      },
                    },
                  })
                }),
                1
              )
            : _c("div", { staticClass: "empty-state" }, [
                _vm._v(
                  " No questions yet. Add up to 10 questions for this Ufu environment. "
                ),
              ]),
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: {
            name: _vm.modalName,
            width: 720,
            height: "auto",
            clickToClose: false,
          },
        },
        [
          _vm.modalVisible
            ? _c("QuestionModal", {
                attrs: { code: _vm.code, question: _vm.selectedQuestion },
                on: { close: _vm.handleModalClose },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }